import { Link } from 'react-router-dom';
import { TextAlignment, TextVariant } from '../../types/v2/text';
import Text from '../typography/v2/text';

type Props = {
  path: string;
  text: string;
  align?: TextAlignment;
  variant?: TextVariant;
};

export default function LinkToItem(props: Props) {
  const { path, text, align, variant } = props;
  return (
    <Link
      className="border-b border-transparent hover:border-off-white"
      to={path}
    >
      <Text variant={variant || 'username'} align={align || 'left'}>
        {text}
      </Text>
    </Link>
  );
}
